<script>

	import Author from '@/components/Author'
	import ArticleListings from '@/components/ArticleListings'

	export default {
		props: {
			entryName: {
				type: String,
				default: 'blogEntry'
			},
			entries: {
				type: Array,
				default () {
					return []
				}
			},
			watermark: Function,
			meta: Function
		},
		render () {
			const filteredEntries = this.entries.filter((entry) => entry.filterFromListings !== true)
			return (
				<container>
					<ArticleListings
						entries={filteredEntries}
						scopedSlots={{
							listing: ({ entry }) => (
								<div class="blog-listing">

									<router-link class="title" to={{ name: this.entryName, params: { slug: entry.slug }}}>
										<figure class="lead-image">
											{this.watermark && this.watermark()}
											<img src={entry.leadThumb} />
										</figure>
										<div class="meta">
											{this.meta && this.meta(entry)}
										</div>
										{entry.title}
									</router-link>

									{entry.author && (
										<Author
											headshot={entry.author.headshot}
											title={`By ${entry.author.title}`}
											class="author"
										/>
									)}

									<div class="intro" domPropsInnerHTML={entry.intro} />

								</div>
							)
						}}
					/>
				</container>
			)
		}
	}

</script>

<style lang="scss" scoped>

	@import "responsive-font";

	.blog-listing {
		@include responsive-font(10);
	}

	.meta {
		@include responsive-font(14);
		color:rgba(#6D6E71, .6); line-height:1.3; margin-bottom:.3em;
	}

	.title {
		@include responsive-font(20);
		//display:block; text-decoration:none; color:#3D3D3D; line-height:1.4;
		display:block; text-decoration:none; color:#3D3D3D; line-height:1.4;
	}

	.lead-image {
		margin-bottom:.75em; position:relative;
		img {
			display:block;
		}
	}

	.author {
		margin-top:1em;
		/deep/ {
			img {
				border-radius:50%; overflow:hidden;
			}
		}
	}

	.intro {
		@include responsive-font(17);
		color:#6D6E71; line-height: 1.45;
		/deep/ {
			img {
				display:none;
			}
			a {
				color:#3D3D3D;
			}
		}
	}

	.author + .intro {
		margin-top:1em;
	}

</style>



// WEBPACK FOOTER //
// src/components/BlogListings.vue